
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class PlaylistSkipControls extends Vue {
  @Prop() public playlist!: any[];
  @Prop() public currentIndex!: number;

  get canGoPrevious(): boolean {
    return this.currentIndex > 0;
  }

  get canGoNext(): boolean {
    return this.currentIndex < this.playlist.length - 1;
  }

  public skipToNext() {
    if (this.canGoNext) {
      this.$emit('next');
    }
  }

  public skipToPrevious() {
    if (this.canGoPrevious) {
      this.$emit('previous');
    }
  }
}
